import { render, staticRenderFns } from "./ManterProcuradorExibir.vue?vue&type=template&id=3015a414&scoped=true&"
import script from "./ManterProcuradorExibir.vue?vue&type=script&lang=js&"
export * from "./ManterProcuradorExibir.vue?vue&type=script&lang=js&"
import style0 from "./ManterProcuradorExibir.vue?vue&type=style&index=0&id=3015a414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015a414",
  null
  
)

export default component.exports